<template>
  <div class="c-l">
    <div class="c-l-t">
      <img style="margin-top: 50px;width:75px;height: 75px;" src="../assets/repert.png" alt="" />
      <div class="c-l-t-s clearfix">
        <span>{{ member.name }}</span>
      </div>
      <div class="c-l-t-g clearfix" :class="member.level == 0 ? 'c-l-t-d' : ''">
        <div class>管理账号</div>
      </div>
    </div>
    <div class="c-l-b">
      <div
        v-for="(item, index) in navItem"
        v-bind:key="index"
        :class="{ active: index == code }"
        class="c-l-b-item"
        @click="gopath(item.name, item.val, index)"
      >
        <span>{{ item.val }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { expertinfo } from "../utils/api.js";
import { Base64 } from "js-base64";
import {
  myOrder,
  Apply,
  ApplyInfo,
  renewOrder, //支付
} from "../utils/api.js";
export default {
  name: "Members",

  data() {
    return {
      isrenew: null,
      state_text: "会员单位",
      code: 0,
      member: {},
      info: {},
      dialogVisible: false,
      dialogVisiblepay: false,
      navItem: [
       {
            val: "分配专家",
            name: "AwardBatch",
          },
         {
            val: "审核材料",
            name: "Awardbatchcgf",
          }
      ],
      wechat: "", //微信支付二维码
      alipay: "",
    };
  },
  watch: {
    $route(to) {
      console.log(to);
      this.cheght(to);
    },
  },
  async mounted() {
    console.log(this.$route);
    this.cheght(this.$route);
    this.getmember();
    var zj_id = localStorage.getItem("zj_id");
  
  },
  methods: {
    async getmember() {
      let member = await expertinfo();
      console.log(987,member);
      this.member = member;
      this.$forceUpdate();
    },
    ispaye() {
      this.dialogVisiblepay = false;
      this.dialogVisible = false;
    },
    gopath(name, title, index) {
      this.code = parseInt(index);
      // let pathname='member/'+name;
      this.$router.push({
        path: name,
        query: {
          name: title,
        },
      });
    },
    cheght(item) {
      const fjjrjk = this.navItem.findIndex((val) => {
        console.log(999, item.path, val.name);
        return item.path.indexOf(val.name) != -1;
      });
      this.code = parseInt(fjjrjk);
    }
  },
};
</script>
<style lang="less" scoped>
.dialog {
  max-width: 454px;
  height: 318px;
  padding: 0 46px;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto;
}
.btn,
.knowbtn {
  cursor: pointer;
  margin: 0 auto;
  margin-top: 18px;
  max-width: 177px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #194abe;
  opacity: 1;
  border-radius: 4px;
  p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 45px;
    color: #194abe;
  }
}
.knowbtn {
  border: 1px solid #7c828a;
  margin-top: 43px;
  p {
    color: #7c828a;
  }
}
.renewtimeout {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #333333;
}
.content {
  margin-top: 16px;
  text-align: start;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #7c828a;
}
.renewtime {
  margin: 0 auto;
  max-width: 224px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 45px;
    color: #e51725;
  }
}
.c-l-t-i-m {
  width: 29px;
  height: 21px;
}

.c-l {
  float: left;
  // width: 268px;

  &-t {
    // width: 268px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 280px;
    background: url("../assets/16.png");
    background-repeat: no-repart;
    background-size: cover;
    padding: 0 20px;
    box-sizing: border-box;

    &-a {
      width: 222px;
      height: 117px;
      margin-top: 30px;
    }

    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 268px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: inline-block;
        max-width: 222px;
      }
    }

    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FAA24B;
      font-size: 16px;
      height: 24px;
      background: linear-gradient(270deg, #fff 0%, #fff 100%);
      opacity: 1;
      margin: 0 auto;
      margin-top: 10px;
      padding: 5px 10px;
    }

    &-d {
      background: #a4aab5 !important;
    }

    &-i {
      display: inline-block;
      float: left;
      cursor: pointer;
    }

    &-t {
      color: #ffffff;
      font-size: 16px;
      opacity: 0.8;
      margin-top: 10px;
    }

    &-b {
      // width: 76px;
      padding: 0px 10px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid #ffffff;
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  &-b {
    width: 268px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;

    &-item {
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #7c828a;
      font-size: 18px;

      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }

  .active {
    background: url("../assets/linhe.png");
    background-repeat: no-repart;
    background-size: contain;
    border-left: 5px solid #194abe;
    color: #194abe;
    font-weight: bold;

    span {
      border: none;
    }
  }
}
</style>
